// "Summary design" in the checkout's summary settings. The picker-less design
// renders OrderOverviewDrawerV4 in place of OrderOverviewDrawerV3.
export const SUMMARY_DESIGN_WITHOUT_PICKER = "without_picker";

export const isSummaryWithoutPicker = () =>
  window.post_template?.checkout_v4_summary?.checkout_v4_summary_design === SUMMARY_DESIGN_WITHOUT_PICKER;
